import { OrderedMap, Record } from 'immutable'

import type { DeepNullable, IFinancialReport } from '@albacross/types'

import { reduceIntoMap } from '../../utils/transforms'
import type { Match, MatchedCompany } from '../api/Match'
import type { FinancialReport, Match as StoreMatch, MatchedCompany as StoreMatchedCompany } from '../store/Match'

export const COMPANIES_PER_PAGE = 20

export const MatchReducerRecord = Record<StoreMatch>({
  matched: OrderedMap() as any,
  total: 0,
  unmatched: 0,
  pristine: true,
  loading: false,
  errors: [],
})

export const MatchedCompanyRecord = Record<DeepNullable<StoreMatchedCompany>>({
  id: 0,
  name: '',
  companyNumber: null,
  country: null,
  city: null,
  website: null,
  naceCode: null,
  industryCode: null,
  revenue: null,
  employees: null,
  selected: false,
  inTargetGroup: false,
})

const revenueFromServer = (x?: IFinancialReport): FinancialReport | null =>
  x
    ? {
        from: x.revenue_from,
        to: x.revenue_to,
        year: x.year,
        currency: x.currency,
      }
    : null

const matchedCompanyFromServer = (x: MatchedCompany) =>
  x
    ? MatchedCompanyRecord({
        id: x.uuid,
        name: x.name,
        companyNumber: x.number,
        country: x.country,
        city: x.address?.city,
        website: x.url,
        naceCode: x.nace_code?.code,
        industryCode: x.linkedin_industry_code?.code,
        revenue: revenueFromServer(x.financial_report),
        employees: x.employees,
        selected: true,
        inTargetGroup: false,
      })
    : MatchedCompanyRecord()

export const matchFromServer = (x: Match) =>
  x
    ? MatchReducerRecord({
        matched: reduceIntoMap(x.matched, matchedCompanyFromServer, undefined, ['uuid']),
        total: x.total,
        unmatched: x.unmatched,
        pristine: false,
        loading: false,
        errors: [],
      })
    : MatchReducerRecord()
